import { Box, Button, Popover, Stack, Typography, useTheme } from '@mui/material'
const AgentClearCheck = ({
  isClearing,
  clearAnchor,
  onClear,
  onCancel,
}: {
  isClearing: boolean
  clearAnchor: HTMLElement | null
  onClear: () => void
  onCancel: () => void
}) => {
  const theme = useTheme()
  return (
    <Popover
      open={isClearing && clearAnchor !== null}
      anchorEl={clearAnchor}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            padding: 1,
            border: `2px solid ${theme.palette.background.defaultdim}`,
          },
        },
      }}
    >
      <Stack gap={2}>
        <Typography sx={{ color: 'text.secondary', fontSize: 12 }}>Clearing messages...</Typography>
        <Typography>Are you sure?</Typography>
        <Box sx={{ display: 'inline-flex', gap: 2 }}>
          <Button variant="outlined" onClick={onCancel} size="small">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onClear}
            size="small"
            color="primary"
            sx={{
              backgroundColor: 'background.defaultdim',
              border: '1px solid',
              borderColor: 'text.errordim',
              '&:hover': {
                borderColor: 'text.error',
              },
            }}
          >
            Confirm
          </Button>
        </Box>
      </Stack>
    </Popover>
  )
}

export default AgentClearCheck
